// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2019 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-open-change-icon {
  width: var(--theia-icon-size);
  height: var(--theia-icon-size);
  background: var(--theia-icon-open-change) no-repeat;
}

.theia-open-file-icon {
  width: var(--theia-icon-size);
  height: var(--theia-icon-size);
  background: var(--theia-icon-open-file) no-repeat;
}

.theia-open-preview-icon {
  width: var(--theia-icon-size);
  height: var(--theia-icon-size);
  background: var(--theia-icon-preview) no-repeat;
}

.theia-open-json-icon {
  width: var(--theia-icon-size);
  height: var(--theia-icon-size);
  background: var(--theia-icon-open-json) no-repeat;
}

.theia-collapse-all-icon {
  background: var(--theia-icon-collapse-all) center center no-repeat;
}

.theia-remove-all-icon {
  background: var(--theia-icon-remove-all) center center no-repeat;
}

.theia-add-icon {
  background: var(--theia-icon-add) center center no-repeat;
}

@keyframes theia-spin {
  100% {
    transform: rotate(360deg);
  }
}

.theia-animation-spin {
  animation: theia-spin 1.5s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/icons.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,mDAAmD;AACrD;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":["/********************************************************************************\n * Copyright (C) 2019 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-open-change-icon {\n  width: var(--theia-icon-size);\n  height: var(--theia-icon-size);\n  background: var(--theia-icon-open-change) no-repeat;\n}\n\n.theia-open-file-icon {\n  width: var(--theia-icon-size);\n  height: var(--theia-icon-size);\n  background: var(--theia-icon-open-file) no-repeat;\n}\n\n.theia-open-preview-icon {\n  width: var(--theia-icon-size);\n  height: var(--theia-icon-size);\n  background: var(--theia-icon-preview) no-repeat;\n}\n\n.theia-open-json-icon {\n  width: var(--theia-icon-size);\n  height: var(--theia-icon-size);\n  background: var(--theia-icon-open-json) no-repeat;\n}\n\n.theia-collapse-all-icon {\n  background: var(--theia-icon-collapse-all) center center no-repeat;\n}\n\n.theia-remove-all-icon {\n  background: var(--theia-icon-remove-all) center center no-repeat;\n}\n\n.theia-add-icon {\n  background: var(--theia-icon-add) center center no-repeat;\n}\n\n@keyframes theia-spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.theia-animation-spin {\n  animation: theia-spin 1.5s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
